import { CivilCaseUtils } from './../civil-case-utils';
import { JL } from 'jsnlog';
import { Attorney } from './attorney';
import { Party } from './party';
import { CourtCosts } from './courtCosts';
import { Pleading } from './pleading';
import { Issue } from './issue';
import { CivilCase } from './../civil-case';
import { SafeJSON } from './../../shared/safe-json';
import { environment } from 'environments/environment';

export class Abstract {

    private json: any;
    private key: string;
    private payoffCalculationsShowFlag: boolean[];

    public static getTranslateAbstractCodeToLabel(code: string): string {
        if (code === 'Q') {
            return 'SPECIAL ABSTRACT';
        }
        return 'JUDGMENT';
    }
    public static convertToNegativeNumber(num: number): number {
        if (num > 0) {
            num = num * -1;
        }
        return num;
    }
    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
        const abstractParties: any[] = this.getAbstractPartiesUnsortedList('D');
        if (abstractParties.length !== 0) {
            this.payoffCalculationsShowFlag = new Array((this.getAbstractPartiesUnsortedList('D').length)).fill(false);
            if (this.getAbstractPartiesUnsortedList('D').length === 1) {
                this.payoffCalculationsShowFlag[0] = true;  // only one debtor, show the calculations
            }
        } else {
            this.payoffCalculationsShowFlag = new Array((1)).fill(false);  // we need at least one flag set in the array
        }
    }
    getKey(): string {
        return this.key;
    }
    getAbstractJudgmentNumber(): Number {
        const numberString = SafeJSON.get('abstractNumber', this.json);
        if (numberString === '') {
            return null;
        }
        const num = Number.parseInt(numberString);
        return num;
    }
    getAbstractSectionTitle(upperCase: boolean): string {
        let text = 'Judgment';
        const code = this.getAbstractCode();
        if (code === 'Q') {
            text = 'Special Abstract';
        }
        if (upperCase) {
            text = text.toUpperCase();
        }
        return text;
    }
    getAbstractCode(): string {
        return SafeJSON.get('abstractCode', this.json);
    }
    getAbstractDateTime(): string {
        return SafeJSON.get('clockDateTime', this.json);
    }
    getAbstractDate(): string {
        const dateTime = SafeJSON.get('enteredDateTime', this.json);
        const index = dateTime.indexOf('T');
        if (index <= 0) {
            return dateTime;
        }
        const date = dateTime.substring(0, index);
        return date;
    }
    getAbstractPartyAssignmentList(): any[] {
        // Display a listing of all the assignments made on the abstract sorted
        // on the Creditor field (as defined in UX319) first and
        // then on the From field in chronological order.

        // Note: if there are a mixture of party codes, then this will need to be reworked.
        const list = SafeJSON.get('abstractPartyAssignmentsList', this.json);
        if (list === '') {
            return [];
        }
        const abstractPartyAssignmentsList: any[] = Array.from(list.values());

        return (abstractPartyAssignmentsList
            .sort( function(p1, p2) {
                const compare = p1.partyCode.partyCode.localeCompare(p2.partyCode.partyCode);
                if (compare !== 0) {
                    return compare;
                }
                return p1.assignmentDate.localeCompare(p2.assignmentDate);
            })
        );
    }
    getAbstractPaymentList(): any[] {
        // Display a listing of all the payments made on the abstract sorted
        const list = SafeJSON.get('paymentList', this.json);
        if (list === '') {
            return [];
        }
        const paymentList: any[] = Array.from(list.values());

        return (paymentList.sort( function(p1, p2) {
            return p1.paymentNumber - p2.paymentNumber;
            })
        );
    }
    // WAKE 2003CVM5509
    // ORANGE 2001CVD191
    getAbstractDisbursementList(civilCase: CivilCase): any[] {
        // this is a map.  convert to an array.
        const disbursementMap =  SafeJSON.get('disbursements', this.json);
        const tempMap = new Map();
        let disbursementList: any[] = new Array();
        Object.keys(disbursementMap).forEach(key => {
            const tempArray = new Array (disbursementMap[key]);
            disbursementList = disbursementList.concat(tempArray[0]);
        });

        // Display a listing of all the disbursements made on the abstract
        if (disbursementList.length === 0) {
            return [];
        }

        /*
        List sorting BR
            UX369	Display a listing of the disbursements on the judgment
            sorted on the Payment Number in ascending order. Within each payment number,
            authorized transactions must be displayed first*, sorted on the
            authorization number in ascending order, and then by Payee Party Type
            in alphabetical order and the Payee Party Sequence Number
            in ascending numerical order.

            *Disbursement transactions with Authorization Dates must be displayed prior
            to the transactions without an Authorization Date.

       disbursementList = disbursementList.sort( function(p1, p2) {
            const comparePaymentNumber = p1.paymentNumber - p2.paymentNumber;
            if (comparePaymentNumber !== 0) {
                return comparePaymentNumber;
            }
            if (p1.paymentAuthorizationNumber === undefined ||
                p2.paymentAuthorizationNumber === undefined) {
                    return 0;
            }
            return p1.paymentAuthorizationNumber.localeCompare(p2.paymentAuthorizationNumber);
        });
          */
        return disbursementList;
    }
    getAbstractPaymentTransactionList(payment): any[] {
        // Display a listing of all the payments made on the abstract sorted
        const list = SafeJSON.get('paymentTransactionList', payment);
        if (list === '') {
            return [];
        }
        const transactionList: any[] = Array.from(list.values());

        transactionList.sort( function(p1, p2) {
            return p1.paymentDate.localeCompare(p2.paymentDate);
            });
        return transactionList;
    }
    getAbstractPaymentSource(transaction): string {
        /*
            BOND_FORFEITURE("AUTO", "BOND FORFEITURE"),
            BONDS("BOND", "BONDS"),
            BOOKKEEPER("BKKP", "BOOKKEEPER"),
            CONVERTED_MFCR("XFCR", "CONVERTED MFCR"),
            CREDITOR_CERTIFIED_PAYMENT("CRED", "CREDITOR-CERTIFIED PAYMENT"),
            DEPT_OF_REVENUE("DORI", "DEPT. OF REVENUE"),
            FMS_PARTIAL_PAY("FMPP", "FMS PARTIAL PAY"),
            INTEREST_WAIVED("INTW", "INTEREST WAIVED"),
            JUDGMENT_DOCKET_BOOK("JDBK", "JUDGMENT DOCKET BOOK"),
            MAINFRAME_CASH_RECEIPTING("MFCR", "MAINFRAME CASH RECEIPTING"),
            MANUAL_ENTRY("JABS", "MANUAL ENTRY"),
            MANUAL_RECEIPT("MANR", "MANUAL RECEIPT"),
            PRESIDING_OFFICIAL("PROF", "PRESIDING OFFICIAL"),
            REDIRECTED_PAYMENT("RDRT", "REDIRECTED PAYMENT");

    */
        return SafeJSON.get('abstractPaymentSource.code', transaction);
    }
    getAbstractPaymentDate(transaction): string {
        return SafeJSON.get('paymentDate', transaction);
    }
    getDetailNumber(detail: any): Number {
        const numberString = SafeJSON.get('detailNumber', detail);
        if (numberString === '') {
            return null;
        }
        const num = Number.parseInt(numberString);
        return num;
    }
    getListOrEmptyArray(id: string): any[] {
        const list = SafeJSON.get(id, this.json);
        if (list === '') {
            return [{}];
        }
        return Array.from(list.values());
    }
    getListOrEmptyArrayFromJson(id: string, json: any): any[] {
        const list = SafeJSON.get(id, json);
        if (list === '') {
            return [];
        }
        return Array.from(list.values());
    }
    getEventDetailList(): any[] {
        const list = this.getListOrEmptyArray('eventDetailsList');
        return list;
    }
    getMoneyDetailList(): any[] {
        const list = this.getListOrEmptyArray('abstractMoneyDetailsList');
        list.sort( function(p1, p2) {
            return Number.parseInt(p1.detailNumber) - Number.parseInt(p2.detailNumber);
        });
        return list;
    }
    getMoneyIntervalList(money: any): any[] {
        const list = this.getListOrEmptyArrayFromJson('intervalList', money);
        list.sort( function(p1, p2) {
            return p1.fromDate.localeCompare(p2.fromDate);
        });
        return list;
    }
    getCostFeesDetailList(): any[] {
        const list = this.getListOrEmptyArray('abstractCostFeesList');
        list.sort( function(p1, p2) {
            return Number.parseInt(p1.detailNumber) - Number.parseInt(p2.detailNumber);
        });
        return list;
    }
    getSpecialAwardDetailList(): any[] {
        const list = this.getListOrEmptyArray('abstractSpecialDetailsList');
        list.sort( function(p1, p2) {
            return Number.parseInt(p1.detailNumber) - Number.parseInt(p2.detailNumber);
        });
        return list;
    }
    getPropertyAwardDetailList(): any[] {
        const list = this.getListOrEmptyArray('abstractPropertyDetailsList');
        list.sort( function(p1, p2) {
            return Number.parseInt(p1.detailNumber) - Number.parseInt(p2.detailNumber);
        });
        return list;
    }
    getAbstractParties(): any {
        return SafeJSON.get('abstractParties', this.json);
    }
    // No need to sort this list, we just want the length of the list
    getAbstractPartiesUnsortedList(type: string): any[] {
        const abstractPartiesMap = this.getAbstractParties();
        const map = new Map();

        Object.keys(abstractPartiesMap).forEach(key => {
            const value = new Issue(abstractPartiesMap[key], key);
            map.set(key, value);
        });
        let abstractPartiesList: any[] = Array.from(map.values());
        return abstractPartiesList.filter(list2 => list2.json.abstractPartyRole.code === type);
    }
    // BURKE 11CVS1563 has a mix of Debtors (D's, P's)
    // This needs to match the sister method in pre-jaabstract.ts
    getAbstractPartiesList(civilCase: CivilCase, type: string): any[] {
        const abstractPartiesMap = this.getAbstractParties();
        const map = new Map();

        Object.keys(abstractPartiesMap).forEach(key => {
            const value = new Issue(abstractPartiesMap[key], key);
            map.set(key, value);
        });
        let abstractPartiesList: any[] = Array.from(map.values());
        abstractPartiesList = abstractPartiesList.filter(list2 => list2.json.abstractPartyRole.code === type);

        /*
            UX319	Based on the case type, parties will be sorted by party role in the specified order and then by party sequence number in
            ascending numerical order within each party role. Party roles will be sorted as follows:

            Getting here means we have the list of Debtors or Creditors.  The parties can be mixed
            so we can have casePartyRefs of D1, P1, D2, D3, P4.  It needs be to sorted
            as D1, D2, D3, P1, P4 for example.
        */
        let caseType = civilCase.getCaseType();
        let partyList: any[] = [];
        if (caseType === 'CR' || caseType === 'CRS' || caseType === 'J') {
            return partyList
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'D'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'F'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'S'))
        }
        if (caseType === 'E' || caseType === 'EO') {
            return partyList
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'E'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'F'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'B'))
        }
        if (caseType === 'SP') {
            return partyList
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'F'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'R'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'D'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'S'))
        }
        if (caseType === 'R') {
            return partyList
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'R'))
        }
        if (caseType === 'M') {
            return partyList
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'D'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'E'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'R'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'S'))
        }
        if (caseType !== 'CVM' && caseType !== 'CVD' && caseType !== 'CVS') {
            // getting here would be an error condition.
            this.logToConsoleAndServer('getAbstractPartiesList: caseType=' + caseType +
                                            ', error - case type not recognized! Using the party list we received from WS.');
        }
        // by default use the CVM ordering
        return partyList
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'D'))
            .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'I'))
    }
    getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList: any[], roleCode: string): Party[] {
        abstractPartiesList = abstractPartiesList.filter(abstractParty =>
            abstractParty.json.casePartyRef.substring(0, 1) === roleCode);

        abstractPartiesList
            .sort( function(p1, p2) {
                const casePartyRef1 = p1.json.casePartyRef;
                let cpr1Number = Number.parseInt(casePartyRef1.slice(1, casePartyRef1.length));

                const casePartyRef2 = p2.json.casePartyRef;
                let cpr2Number = Number.parseInt(casePartyRef2.slice(1, casePartyRef2.length));
                return cpr1Number - cpr2Number;
            })
        ;
        return abstractPartiesList;
    }
    getShowDebtorPayoffCalculation(abstractParty: any): boolean {
        const casePartyRef = SafeJSON.get('casePartyRef', abstractParty.json);
        // UX331 If any Costs or Attorney Fees attached to the abstract have
        //       been identified as ‘To Be Determined’, suppress all information in the
        //       Payoff Calculations section for the debtors listed on the Cost Award Detail.
        const attorneyFeeTypeTBD = this.getAttorneyFeeTypeTBDExists(abstractParty);
        if (attorneyFeeTypeTBD === true) {
            this.logToConsoleAndServer('getShowDebtorPayoffCalculation: found attorney fees TBD for ' + casePartyRef)
            return false;
        }

        // UX394 If the abstract consists of only Property Award Detail,
        //       suppress all information in the Payoff Calculations section for the
        //       debtors on the Property Award Detail.
        if (this.isPropertyAwardDetailOnlyAwardDetail() === true) {
            // if (this.isPartyInAwardDetailList(this.getPropertyAwardDetailList(), casePartyRef) === true) {
                console.log('getShowDebtorPayoffCalculation: only found property award detail list');
                return false;
            // }
        }

        // UX332 If a Special Award Detail exists for the abstract, suppress all information in
        //       the Payoff Calculations section for the debtors on the Special Award Detail.
        if (this.isPartyInAwardDetailList(this.getSpecialAwardDetailList(), casePartyRef) === true) {
            console.log('getShowDebtorPayoffCalculation: found special award detail list and ' + casePartyRef + ' is in it');
            return false;
        }
        return true;
    }

    isPropertyAwardDetailOnlyAwardDetail(): boolean {
        const specialList: any[] = SafeJSON.get('abstractSpecialDetailsList', this.json);
        const propertyList: any[] =  SafeJSON.get('abstractPropertyDetailsList', this.json);
        const moneyList: any[] =  SafeJSON.get('abstractMoneyDetailsList', this.json);
        const costFeesList: any[] =  SafeJSON.get('abstractCostFeesList', this.json);
        // true if Property details the only detail
        if (propertyList.length !== 0 &&
            specialList.length === 0 &&
            moneyList.length === 0 &&
            costFeesList.length === 0) {
            return true;
        }
        return false;
    }
    isPartyInAwardDetailList(awardDetailList: any[], casePartyRef: string): boolean {
        for (let i = 0; i < awardDetailList.length; i++) {
            let abstractPartyLiableList: any[] = SafeJSON.get('abstractPartyLiableList', awardDetailList[i]);
            if (abstractPartyLiableList.length === 0) {
                return false;
            }
            abstractPartyLiableList = abstractPartyLiableList.filter(list => list.casePartyRef === casePartyRef);
            if (abstractPartyLiableList.length > 0) {
                return true;
            }
        }
        return false;
    }
    // this case sorting must match what's in civil-case.getPartyList()
    getAbstractPartyLiableList(civilCase: CivilCase, detailsList: any, abstractPartyRoleCode: string): any[] {
        const list = this.getListOrEmptyArrayFromJson('abstractPartyLiableList', detailsList);
        const liableList = list.filter(list2 => list2.abstractPartyRole.code === abstractPartyRoleCode);
        const orderedList: any[] = [];
        const caseType = civilCase.getCaseType();
        if (caseType === 'CR' || caseType === 'CRS' || caseType === 'J') {
            return orderedList
                .concat(this.getSortedPartiesByType(liableList, 'P'))
                .concat(this.getSortedPartiesByType(liableList, 'D'))
                .concat(this.getSortedPartiesByType(liableList, 'F'))
                .concat(this.getSortedPartiesByType(liableList, 'S'));
        }
        if (caseType === 'E' || caseType === 'EO') {
            return orderedList
            .concat(this.getSortedPartiesByType(liableList, 'E'))
            .concat(this.getSortedPartiesByType(liableList, 'F'))
            .concat(this.getSortedPartiesByType(liableList, 'B'));
        }
        if (caseType === 'SP') {
            return orderedList
            .concat(this.getSortedPartiesByType(liableList, 'P'))
            .concat(this.getSortedPartiesByType(liableList, 'R'))
            .concat(this.getSortedPartiesByType(liableList, 'E'))
            .concat(this.getSortedPartiesByType(liableList, 'F'))
            .concat(this.getSortedPartiesByType(liableList, 'S'));
        }
        if (caseType === 'R') {
            return orderedList
            .concat(this.getSortedPartiesByType(liableList, 'P'))
            .concat(this.getSortedPartiesByType(liableList, 'R'));
        }
        if (caseType === 'M') {
            return orderedList
            .concat(this.getSortedPartiesByType(liableList, 'P'))
            .concat(this.getSortedPartiesByType(liableList, 'D'))
            .concat(this.getSortedPartiesByType(liableList, 'E'))
            .concat(this.getSortedPartiesByType(liableList, 'F'))
            .concat(this.getSortedPartiesByType(liableList, 'S'));
        }
        if (caseType !== 'CVM' && caseType !== 'CVD' && caseType !== 'CVS') {
            console.log('Error in getAbstractPartyLiableList() - case type not recognized ' + caseType);
        }
        // Nothing else matched, so use the CVM ordering by default
        return orderedList
            .concat(this.getSortedPartiesByType(liableList, 'P'))
            .concat(this.getSortedPartiesByType(liableList, 'D'))
            .concat(this.getSortedPartiesByType(liableList, 'I'));
    }
    getSortedPartiesByType(liableList: any[], type: string): any[] {
        // we need to sort by the party ref number so pull it out and sort by that.
        let list = liableList.filter(list2 => list2.casePartyRef.substring(0, 1) === type);
        list = list.sort( function(p1, p2) {
            let cpr1Number = Number.parseInt(p1.casePartyRef.slice(1, p1.casePartyRef.length));
            let cpr2Number = Number.parseInt(p2.casePartyRef.slice(1, p2.casePartyRef.length));
            return cpr1Number - cpr2Number;
        });
        return list;
    }
    getOrderPartyIssuesList(): any[] {
        const list = this.getListOrEmptyArray('issueOrderPartyRef');
        return list;
    }
    getCreditor(civilCase: CivilCase, assignment: any): string {
        const partyRef = SafeJSON.get('partyCode.partyCode', assignment);
        const partyName = civilCase.getPartyNameByPartyRef(partyRef);
        const partyDescription = civilCase.getPartyDescriptionByPartyRef(partyRef);
        const partyNumber = civilCase.getPartyNumberByPartyRef(partyRef);
        if (partyDescription === '-' || partyName === '-' || partyNumber === undefined) {
            return '-';
        }
        return partyName + ' (' + partyDescription + ' ' + partyNumber + ')';
    }
    getAssignmentDate(assignment: any): string {
        return SafeJSON.get('assignmentDate', assignment);
    }
    getCancelledDate(assignment: any): string {
        return SafeJSON.get('cancelledDate', assignment);
    }
    getAssignmentNumber(assignment: any): string {
        return SafeJSON.getWithDefault('assignmentNumber', assignment);
    }
    getAssignmentName(assignment: any): string {
        return SafeJSON.getWithDefault('assigneeName', assignment) + ' (ASSIGNEE ' + this.getAssignmentNumber(assignment) + ')';
    }
    getAbstractStatus(): string {
        const abstractStatusCode = this.getAbstractStatusCode();
        if (abstractStatusCode === 'CNCL') {
            return 'CANCELLED';
        }
        if (abstractStatusCode === 'VACT') {
            return 'VACATED';
        }
        if (abstractStatusCode === 'MODF') {
            return 'MODIFIED';
        }
        if (this.getAbstractCancelReasonCode() === 'STWB') {
            return 'UNENFORCEABLE';
        }
        return '';
    }
    getAbstractStatusCode(): string {
        return SafeJSON.getWithDefault('abstractStatus.code', this.json);
    }
    getAbstractCancelReasonCodeDescription(): string {
        const description = SafeJSON.get('abstractCancelReasonCode.description', this.json);
        if (description !== '') {
            return ', ' + description;
        }
    }
    getAbstractCancelReasonCode(): string {
        return SafeJSON.getWithDefault('abstractCancelReasonCode.code', this.json);
    }
    getAbstractStatusDescription(): string {
        return SafeJSON.getWithDefault('abstractStatus.description', this.json);
    }
    getClockedInOnDate(): string {
         return SafeJSON.get('clockDateTime', this.json);
    }
    getAbstractType(): string {
        return SafeJSON.getWithDefault('abstractType.description', this.json);
    }
    getAbstractTypeCode(): string {
        return SafeJSON.getWithDefault('abstractType.code', this.json);
    }
    getEntryType(): string {
        return SafeJSON.getWithDefault('entryType.description', this.json);
    }
    getVacatedDate(): string {
        return SafeJSON.get('vacatedDate', this.json);
    }
    getAbstractStatusDate(): string {
        const abstractStatusCode = this.getAbstractStatusCode();
        if (abstractStatusCode === 'CNCL') {
            return SafeJSON.get('cancelDate', this.json);
        }
        if (abstractStatusCode === 'VACT'
         || this.getAbstractCancelReasonCode() === 'STWB') {
            return this.getVacatedDate();
        }
        return '';
    }
    getPlusInterestAttorneyFeeText(detail: any): string {
        const intervalList: any[] = SafeJSON.get('intervalList', detail);
        let hasInterestInterval = false;
        if (intervalList !== undefined && intervalList.length > 0) {
            hasInterestInterval = true;
        }

        let hasPreJudgmentInterestAmount = false;
        let preJudgmentInterestAmountNumber: Number = 0;
        let preJudgmentInterestAmountString = SafeJSON.getWithDefault('preJudgmentInterestAmount', detail);
        if (preJudgmentInterestAmountString !== '-') {
            preJudgmentInterestAmountNumber = Number(preJudgmentInterestAmountString);
            if (preJudgmentInterestAmountNumber !== 0) {
                hasPreJudgmentInterestAmount = true;
            }
        }

        let hasAttorneyFeeAmount = false;
        let preAttorneyFeeAmountNumber: Number = 0;
        let preAttorneyFeeAmountString = SafeJSON.getWithDefault('attorneyFeeAmount', detail);
        if (preAttorneyFeeAmountString !== '-') {
            preAttorneyFeeAmountNumber = Number(preAttorneyFeeAmountString);
            if (preAttorneyFeeAmountNumber !== 0) {
                hasAttorneyFeeAmount = true;
            }
        }

        let hasAttorneyFeeTBDAmount = false;
        let preAttorneyFeeTBDAmountString = SafeJSON.getWithDefault('abstractAttorneyFeeType.code', detail);
        if (preAttorneyFeeTBDAmountString === 'TBD') {
            hasAttorneyFeeTBDAmount = true;
        }

        const principalAmount: number = SafeJSON.getNumber('principalAmount', detail);

        if ((hasInterestInterval || hasPreJudgmentInterestAmount) && !hasAttorneyFeeAmount && !hasAttorneyFeeTBDAmount) {
            return 'plus interest';
        }
        /*
        Viparna: Basically for the “interest” to appear in the heading for these two business rules,
        we need to have either the pre-judgment interest amount or an interest interval, or both.

        UX351.3
        If the money details contains the principal amount and attorney fees,
        but no pre-judgment interest amount or an interest interval,
        display as
        “Money Award Detail ” + < Money Detail Sequence Number > + “: “ + < Principal > +
         “ plus attorney fees” + “(“ + <Money Detail Status> + “)”.
        Example: Money Award Detail 1: $10,000.00 plus attorney fees (MODIFIED)
        */
        if (principalAmount > 0 && hasAttorneyFeeAmount && (!hasPreJudgmentInterestAmount && hasInterestInterval)) {
            return 'plus attorney fees';
        }
        /*
        UX351.2
        If the money details contains the principal amount,
        a pre-judgment interest amount or at least one interest interval,
        and attorney fees, display as
        “Money Award Detail ” + < Money Detail Sequence Number > + “: “ + < Principal > +
        “ plus interest and attorney fees” + “(“ + <Money Detail Status> + “)”.
        Example: Money Award Detail 1: $10,000.00 plus interest and attorney fees (MODIFIED)
        */
        if (principalAmount > 0  && hasAttorneyFeeAmount && (hasPreJudgmentInterestAmount || hasInterestInterval)) {
            return 'plus interest and attorney fees';
        }

        if (!hasInterestInterval && !hasPreJudgmentInterestAmount && hasAttorneyFeeAmount && !hasAttorneyFeeTBDAmount) {
            return 'Attorney fees only';
        }
        if (!hasInterestInterval && !hasPreJudgmentInterestAmount && hasAttorneyFeeAmount && hasAttorneyFeeTBDAmount) {
            return 'Attorney fees are to be determined';
        }
        if (!hasPreJudgmentInterestAmount && principalAmount === 0 && hasAttorneyFeeTBDAmount) { // UX351.5
            return 'Attorney fees are to be determined';
        }
        return '';
    }
    getAbstractDetailStatus(detail: any): string {
        const status = SafeJSON.getWithDefault('abstractDetailStatus.description', detail);
        const cancelDate = this.getDetailCancelDate(detail);
        if (status === '-') {
            return '';
        }
        return '(' + status + cancelDate + ')';
    }
    getAbstractPartyLiableStatus(detail: any): string {
        const status = SafeJSON.getWithDefault('partyLiableStatus.description', detail);
        if (status === '-') {
            return '';
        }
        return status;
    }
    getDebtorDetailStatus(detail: any): string {
        const status = SafeJSON.getWithDefault('abstractDetailStatus.description', detail);
        if (status === '-') {
            return '';
        }
        return '(' + status + ')';
    }
    getPreJudgmentType(detail: any): string {
        return SafeJSON.getWithDefault('preJudgmentType.description', detail);
    }
    getCostDetail(detail: any): number {
        let total = 0;
        const attorneyFeeAmount: number = SafeJSON.getNumber('attorneyFeeAmount', detail);
        const postJudgmentCostAmount: number = this.postJudgmentCostAmount(detail);
        const preJudgmentCostAmount: number = SafeJSON.getNumber('preJudgmentCostAmount', detail);
        total = attorneyFeeAmount + postJudgmentCostAmount + preJudgmentCostAmount;
        return total;
    }
    postJudgmentCostAmount(detail: any): number {
        return SafeJSON.getNumber('postJudgmentCostAmount', detail);
    }
    getDetailDescription(detail: any): string {
        const textDescriptionList: any[] = SafeJSON.get('textDescriptionList', detail);
        if (textDescriptionList.length === 0 || textDescriptionList === undefined) {
            return '';
        }
        let description = '';
        for (let i = 0; i < textDescriptionList.length; i++) {
            description = description + ' ' + SafeJSON.get('textDescriptionList[' + i + '].description', detail);
        }
        return description;
    }

    // Money Award Detail section //////////////////////////////////////////////
    getPrincipalAmount(money: any): number {
        return SafeJSON.getNumber('principalAmount', money);
    }
    getMoneyAwardDetailPreJudgmentInterest(money: any): number {
        return SafeJSON.getNumber('preJudgmentInterestAmount', money);
    }
    getMoneyAwardDetailFromDate(interval: any): string {
        return SafeJSON.get('fromDate', interval);
    }
    getMoneyAwardDetailThroughDate(interval: any): string {
        const throughDate = SafeJSON.get('thruDate', interval);
        return throughDate;
    }
    getMoneyAwardDetailInterestMoney(interval: any): Number {
        const amount = SafeJSON.getWithDefault('amount', interval);
        if (amount === '-') {
            return this.formatInterestRate(SafeJSON.getNumber('interestRate', interval) * 100);
        }
        return null;
    }
    getMoneyAwardDetailInterestMoneyDescription(interval: any): string {
        const amount = SafeJSON.getWithDefault('amount', interval);
        if (amount === '-') {
            const rateDescription = this.getSimpleCompoundIndicator(interval);
            return rateDescription;
        }
        return '';
    }
    getSimpleCompoundIndicator(interval: any): string {
        return SafeJSON.getWithDefault('simpleCompoundIndicator.description', interval);
    }
    getMoneyAwardDetailPerDayMoney(interval: any): string {
        const amount = SafeJSON.getWithDefault('amount', interval);
        if (amount === '-') {
            return '';
        }
        return amount;
    }
    getAbstractDetailPartyName(civilCase: CivilCase, abstractDetail: any): string {
        const partyRef = SafeJSON.get('casePartyRef', abstractDetail);
        const partyName = civilCase.getPartyNameByPartyRef(partyRef);
        return partyName;
    }
    getAbstractDetailPartyDescription(civilCase: CivilCase, abstractDetail: any): string {
        const partyRef = SafeJSON.get('casePartyRef', abstractDetail);
        const partyNumber = civilCase.getPartyNumberByPartyRef(partyRef);
        return civilCase.getPartyDescriptionByPartyRef(partyRef) + ' ' + partyNumber;
    }

    // Property Award Detail section //////////////////////////////////////////////
    getPropertyCountyRegisterOfDeeds(property: any): string {
        let county = this.getPropertyRegisterDeedsCounty(property);
        if (county === '-') {
            county = this.getPropertyRegisterDeedsCountyNumber(property);
        }
        if (county === '-') {
            return '';
        }
        const registerDeedsBook = this.getPropertyRegisterDeedsBook(property);
        const registerDeedsPage = this.getPropertyRegisterDeedsPage(property);
        return ': ' + county + ' County Register of Deeds Book ' + registerDeedsBook + ', Page ' + registerDeedsPage;
    }
    getPropertyRegisterDeedsCountyNumber(property: any): string {
        return SafeJSON.getWithDefault('registerDeedsCountyNumber', property);
    }
    getPropertyRegisterDeedsCounty(property: any): string {
        return SafeJSON.getWithDefault('registerDeedsCounty', property);
    }
    getPropertyRegisterDeedsBook(property: any): string {
        return SafeJSON.getWithDefault('registerDeedsBook', property);
    }
    getPropertyRegisterDeedsPage(property: any): string {
        return SafeJSON.getWithDefault('registerDeedsPage', property);
    }
    public getAffectedParty(civilCase: CivilCase, abstractParty: any): string {
        const casePartyRef = SafeJSON.getWithDefault('casePartyRef', abstractParty.json);
        const partyName = civilCase.getPartyNameByPartyRef(casePartyRef);
        const partyRole = civilCase.getPartyDescriptionByPartyRef(casePartyRef);
        const partyNumber = civilCase.getPartyNumberByPartyRef(casePartyRef);
        return partyName + ' (' + partyRole + ' ' + partyNumber + ')';
    }
    UnPaidIndigentCosts(abstractParty: any): string {
        const UnPaidIndigentCosts = SafeJSON.getWithDefault('UnPaidIndigentCosts', abstractParty.json);
        return UnPaidIndigentCosts;
    }
    getAfffectedPartyStatus(civilCase: CivilCase, abstractParty: any): string {
        const abstractPartyStatus = SafeJSON.getWithDefault('abstractPartyStatus.description', abstractParty.json);
        const abstractPartyStatusCode = SafeJSON.getWithDefault('abstractPartyStatus.code', abstractParty.json);
        const date = '';
        if (abstractPartyStatusCode === 'CNCL') {
            return 'CANCELLED';
        }
        if (abstractPartyStatusCode === 'VACT') {
            return 'VACATED';
        }
        if (abstractPartyStatus === '-') {
            return 'ACTIVE';
        }
        return abstractPartyStatus;
    }
    getAfffectedPartyCancelDateIfPresent(civilCase: CivilCase, abstractParty: any): string {
        const abstractPartyStatus = SafeJSON.getWithDefault('abstractPartyStatus', abstractParty.json);
        let date = '';
        if (abstractPartyStatus.code === 'CNCL') {
            date = SafeJSON.get('cancelDate', abstractParty.json);
        }
        if (abstractPartyStatus.code === 'VACT') {
            date = SafeJSON.get('cancelDate', abstractParty.json);
        }
        return date;
    }
    getPleadingKeyByIssueOrderParty(civilCase: CivilCase, issueOrderParty: any): Pleading {
        /*
        issues
             issueOrderPartyRef (look for abstractRef of the one we're working with)
                use this issue to get pleading key and access needed data; go to next issue
        */
        const issue: Issue = civilCase.getIssueListByKey(issueOrderParty.issueRef);
        if (issue === undefined) {
            return new Pleading(this.json, '');
        }
        const pleadingKey = issue.getPleadingKey();
        const pleading: Pleading = civilCase.getPleadingByKey(pleadingKey);
        return pleading;
    }
    getItemizedOtherCostsAmount(costDetail: any): number {
        const amount: string = SafeJSON.get('postJudgmentCostAmount', costDetail);
        if (amount === '') {
            return 0;
        }
        return Number(amount);
    }
    getAttorneyFees(costDetail: any): number {
        const amount: string = SafeJSON.get('attorneyFeeAmount', costDetail);
        if (amount === '') {
            return 0;
        }
        return Number(amount);
    }
    getAttorneyFeesTBD(costDetail: any): string {
        const text: string = SafeJSON.get('absAttorneyFeeType.description', costDetail);
        return text;
    }
    getAttorneyFeesPlusTBD(costDetail: any): string {
        const text: string = this.getAttorneyFeesTBD(costDetail);
        if (text === 'TO BE DETERMINED') {
            return 'plus attorney fees to be determined';
        }
        return '';
    }
    getItemizedCostsAmountTotal(costDetail: any): Number {
        const total = this.getAttorneyFees(costDetail) +
                    this.getItemizedOtherCostsAmount(costDetail) +
                    SafeJSON.getNumber('preJudgmentCostAmount', costDetail);
        return total;
    }
    // FBR464
    getAttorneyFeesAwrd(money: any): string {
        const abstractAttorneyFeeTypeCode: string = SafeJSON.getWithDefault('abstractAttorneyFeeType.code', money);
        const amount: Number = this.getAttorneyFees(money);
        let interestRate: number = SafeJSON.getNumber('attorneyFeePercent', money);

        if (abstractAttorneyFeeTypeCode === 'AWRD' && amount > 0 && interestRate === 0) {
            return 'Attorney fees are awarded in the amount of ';
        }
        return '-';
    }
    // FBR465  Catawba 2003CVD1013
    // FBR466  Vance 1997CVD1004
    getAttorneyFeesPercentAwrd(money: any): string {
        const abstractAttorneyFeeTypeCode: string = SafeJSON.getWithDefault('abstractAttorneyFeeType.code', money);
        let interestRate: number = SafeJSON.getNumber('attorneyFeePercent', money) * 100;
        let attorneyFeeAmount: number = SafeJSON.getNumber('attorneyFeeAmount', money);
        let attorneyFeeAmountString = CivilCaseUtils.formatNumberToCurrency(attorneyFeeAmount);
        let preJudgmentInterestAmount: number = SafeJSON.getNumber('preJudgmentInterestAmount', money);
        let principalAmount: number = this.getPrincipalAmount(money);
        let calculatedInterestAmount: number = principalAmount * interestRate / 100;
        if (!environment.production) {
           // console.log('Attorney Fee =' + attorneyFeeAmount
           //           + '| calculated interated amount = ' + calculatedInterestAmount
           //           + '| Pre-jdugement Interest Amount = ' + preJudgmentInterestAmount );
        }
        let preJudgmentInterestText = '';
        // if (attorneyFeeAmount === preJudgmentInterestAmount  || preJudgmentInterestAmount === 0) {
        if (attorneyFeeAmount === calculatedInterestAmount ) {
            preJudgmentInterestText = ' ONLY';                      // FBR465  - CQ TSD00037537/TSD00037650
        } else if ( attorneyFeeAmount > preJudgmentInterestAmount ) {
            preJudgmentInterestText = ' AND PREJUDGMENT INTEREST';  // FBR466
        }
        if (abstractAttorneyFeeTypeCode === 'AWRD' && interestRate > 0) {
            return 'Attorney fees are awarded in the amount of ' + attorneyFeeAmountString +
                   ', which is ' + interestRate + '% of PRINCIPAL' + preJudgmentInterestText + '.';
        }
        return '';
    }
    // FBR467
    getAttorneyFeesTbd(money: any): string {
        const abstractAttorneyFeeTypeCode: string = SafeJSON.getWithDefault('abstractAttorneyFeeType.code', money);
        if (abstractAttorneyFeeTypeCode === 'TBD') {
            return 'Attorney fees are to be determined';
        }
        return '-';
    }
    getAttorneyFeesAwrdMoney(money: any): string {
        return SafeJSON.get('attorneyFeeAmount', money);
    }

    getDetailPartyLiableCancelDate(detail: any): string {
        const code = SafeJSON.getWithDefault('partyLiableStatus.code', detail);
        if (code === 'CNCL') {
            return ' ' + SafeJSON.get('cancelDate', detail);
        }
        return '';
    }
    getMaxAttorneyAmount(detail: any): number {
        let amount = SafeJSON.get('maxAttorneyAmount', detail);
        if (amount === '') {
            amount = 0;
        }
        return amount;
    }
    getMaxPreLiabilityAmount(detail: any): number {
        let amount = SafeJSON.get('maxPreLiabilityAmount', detail);
        if (amount === '') {
            amount = 0;
        }
        return amount;
    }
    getMaxPostLiabilityAmount(detail: any): number {
        let amount = SafeJSON.get('maxPostLiabilityAmount', detail);
        if (amount === '') {
            amount = 0;
        }
        return amount;
    }
    getDetailCancelDate(detail: any): string {
        const status = SafeJSON.getWithDefault('abstractParties.abstractStatus.code', detail);
        if (status === 'CNCL') {
            return ' ' + SafeJSON.get('cancelDate', this.json);
        }
        return '';
    }
    getItemizedCostList(civilCase: CivilCase, abstractNumber: string, abstractCode: string, detailNumber: string): CourtCosts[] {
        // this is a map.  convert to an array   xxxx
        const courtCostsMap = SafeJSON.get('courtCosts', civilCase.json);
        const tempMap = new Map();
        Object.keys(courtCostsMap).forEach(key => {
            const value = new CourtCosts (courtCostsMap[key], key);
            tempMap.set(key, value);
        });
        const courtCostsList: CourtCosts[] = Array.from(tempMap.values());
        const abstractCostFeesList: any[] = this.getCostFeesDetailList();
        const result: CourtCosts[] = [];

        for (let i = 0; i < courtCostsList.length; i++) {
            const itemizedCostAbstractNumber = courtCostsList[i].getAbstractNumber();
            const itemizedCostAbstractCode = courtCostsList[i].getAbstractCode();

            // we only want to look at the itemized costs for this abstract
            if (Number(abstractNumber) === Number(itemizedCostAbstractNumber)
                && abstractCode === itemizedCostAbstractCode) {

                const dtlNumber = courtCostsList[i].getDetailNumber();

                for (let j = 0; j < abstractCostFeesList.length; j++) {
                    const cfDetailNumber: string = abstractCostFeesList[j].detailNumber;

                    // we only want to look at cost fees for this detail number
                    if (Number(dtlNumber) === Number(detailNumber)
                        && Number(cfDetailNumber) === Number(detailNumber)) {
                        result.push(courtCostsList[i]);
                    }
                }
            }
        }
        /*  Note David Finley helped with this sort.  Its not chained, it is nested which is what I want. */
        result.sort( function(p1, p2) {
            const compare = p1.getItemizedCostsDate().localeCompare(p2.getItemizedCostsDate());
            if (compare !== 0) {
                return compare;
            }
            return p1.getItemizedCostsTypeOfCost().localeCompare(p2.getItemizedCostsTypeOfCost());
        });
        return result;
    }
    getDetailStringName(name: string): string {
        return name;
    }
    getPaymentsOnJudgmentPaymentNumber(payment: any): string {
        const paymentNumber = SafeJSON.getWithDefault('paymentNumber', payment);
        return paymentNumber;
    }
    getPaymentsOnJudgmentTransactionDate(transaction: any): string {
        let paymentDate = SafeJSON.getWithDefault('paymentDate', transaction);
        return paymentDate;
    }
    getPaymentsOnJudgmentTransactionType(transaction: any): string {
        const abstractPaymentType = SafeJSON.getWithDefault('abstractPaymentType.description', transaction);
        return abstractPaymentType;
    }
    getPaymentsOnJudgmentAmount(payment: any, positive: boolean): number {
        let amount: number = SafeJSON.getWithDefault('amount', payment);
        if (positive) {
            if (amount < 0) {
                amount = amount * -1;
            }
        }
        return amount;
    }
    getAdjustedPaymentAmount(payment: any, positive: boolean): number {
        const transactionList: any[] = this.getAbstractPaymentTransactionList(payment);
        let total = 0;
        for (let i = 0; i < transactionList.length; i++) {
            const transaction = transactionList[i];
            total = total + SafeJSON.getWithDefault('amount', transaction);
        }
        if (positive) {
            if (total < 0) {
                total = total * -1;
            }
        }
        return total;
    }
    getShowAdjustedPayment(payment: any): boolean {
        const transactionList: any[] = this.getAbstractPaymentTransactionList(payment);
        const total = 0;
        for (let i = 0; i < transactionList.length; i++) {
            const type: string = this.getPaymentsOnJudgmentTransactionType(transactionList[i]);
            if (type === 'REVERSING ENTRY' || type === 'RETURNED CHECK' || type === 'VOIDED CHECK' || type === 'REFUND') {
                return true;
            }
        }
        return false;
    }
    getShowPayoffAmountNotAccurateMessage(): boolean {
        const specialList: any[] = SafeJSON.get('abstractSpecialDetailsList', this.json);
        const propertyList: any[] =  SafeJSON.get('abstractPropertyDetailsList', this.json);
        if (propertyList.length !== 0 || specialList.length !== 0) {
            return true;
        }
        return false;
    }
    getPaymentsOnJudgmentDebtor(civilCase: CivilCase, payment: any): string {
        const partyRef = SafeJSON.getWithDefault('partyRef', payment);
        const partyName = civilCase.getPartyNameByPartyRef(partyRef);
        const partyRole = civilCase.getPartyDescriptionByPartyRef(partyRef);
        const partyNumber = civilCase.getPartyNumberByPartyRef(partyRef);
        return partyName + ' (' + partyRole + ' ' + partyNumber + ')';
    }
    getPaymentsOnNoticeDescriptionToCreditor(civilCase: CivilCase, transaction: any): string {
        const notice = SafeJSON.getWithDefault('noticeIndicator.description', transaction);
        if (notice === 'RETURNED CHECK' || notice === 'VOIDED CHECK' || notice === 'REVERSING ENTRY') {
            // console.log('suppress notice of payment for ' + notice);
            return '-';
        }
        /*
        FBR533  The notice of payment statement will be suppressed on ‘PAYMENT’ transactions
                with a notice date for the following conditions:

            FBR533.1    If the payment source is ‘FMPP’ and the Transaction Date is before the
                        Abstracted on Date.
        */
        if (this.getAbstractPaymentSource(transaction) === 'FMPP' &&
            this.getAbstractPaymentDate(transaction) < this.getAbstractDate()) {
                // console.log('suppress notice of payment for FBR533.1');
                return '-';
        }
        /*
            FBR533.2     If the payment source is 'CRED', 'AUTO', 'BOND', 'BKKP', 'DORI' 'JDBK', 'PROF', 'XFCR', ‘INTW’
            or
            when the disbursement is to an indigent cost.
        */
        if (this.getAbstractPaymentSource(transaction) === 'CRED' ||
            this.getAbstractPaymentSource(transaction) === 'AUTO' ||
            this.getAbstractPaymentSource(transaction) === 'BOND' ||
            this.getAbstractPaymentSource(transaction) === 'BKKP' ||
            this.getAbstractPaymentSource(transaction) === 'DORI' ||
            this.getAbstractPaymentSource(transaction) === 'JDBK' ||
            this.getAbstractPaymentSource(transaction) === 'PROF' ||
            this.getAbstractPaymentSource(transaction) === 'XFCR' ||
            this.getAbstractPaymentSource(transaction) === 'INTW' ||
            this.isDisbursementItToIndigentCost()) {
                // console.log('suppress notice of payment for FBR533.2');
                return '-';
        }
        /*
            FBR533.3  If the payment source is 'MFCR', 'MANR', 'JABS', 'RDRT'
            and
            the Abstract Source is 'APFE' , ‘AUTO’ or ‘JATF’.
        */
        if ((this.getAbstractPaymentSource(transaction) === 'MFCR' ||
             this.getAbstractPaymentSource(transaction) === 'MANR' ||
             this.getAbstractPaymentSource(transaction) === 'JABS' ||
             this.getAbstractPaymentSource(transaction) === 'RDRT' )
             &&
            (this.getAbstractTypeCode() === 'APFE' ||
             this.getAbstractTypeCode() === 'AUTO' ||
             this.getAbstractTypeCode() === 'JATF')) {
                // console.log('suppress notice of payment for FBR533.3');
                return '-';
        }
        /*
            FBR533.4  If the payment source is 'MFCR', 'MANR', 'JABS', or 'RDRT'
            and
            Abstract Source is ‘ARBF’ with a case type of ‘Miscellaneous’.
        */
        if ((this.getAbstractPaymentSource(transaction) === 'MFCR' ||
             this.getAbstractPaymentSource(transaction) === 'MANR' ||
             this.getAbstractPaymentSource(transaction) === 'JABS' ||
             this.getAbstractPaymentSource(transaction) === 'RDRT' )
             &&
            (this.getAbstractTypeCode() === 'ARBF' && civilCase.getCaseType() === 'M')) {
                // console.log('suppress notice of payment for FBR533.4');
                return '-';
        }
        return notice;
    }
    isDisbursementItToIndigentCost() {  // TODO
        /*
        In the disbursementList section, when the mailOverrideIndicator = ‘I’,
        then it’s disbursed to an indigent cost.  You’ll need to match on the payment number
        from the paymentList section.
        */
        return false;
    }
    getPaymentsOnNoticeDateToCreditor(transaction: any): string {
        let noticeDate = SafeJSON.getWithDefault('noticeDate', transaction);
        return noticeDate;
    }
    getDistributionsOnJudgmentPaymentNumber(disbursement: any): string {
        return SafeJSON.getWithDefault('paymentNumber', disbursement);
    }
    getDistributionsOnJudgmentAuthorizationNumber(disbursement: any): string {
        return SafeJSON.getWithDefault('paymentAuthorizationNumber', disbursement);
    }
    getDistributionsOnJudgmentAuthorizationDate(disbursement: any): string {
        return SafeJSON.get('paymentAuthorizationDate', disbursement);
    }
    getDistributionsOnJudgmentPayoffDispute(disbursement: any): string {
        return SafeJSON.getWithDefault('payoffDispute', disbursement);
    }
    getDistributionsOnJudgmentStatus(disbursement: any): string {
        return SafeJSON.getWithDefault('disbursementStatus', disbursement);
    }
    getDistributionsOnJudgmentAmount(disbursement: any): number {
        return SafeJSON.getNumber('grossDistributionAmt', disbursement);
    }
    getAbstractDisbursementCreditorList(civilCase: CivilCase, disbursement: any): any[] {
        /*
        V068.t – Payee Name
        UX371	    Display all the payee name(s) designated to receive the payment
                    sorted by Party Type first and then by Party Sequence Number
                    in ascending numerical order within each Party Type.

        Test with WAKE 00CVS014502
        */
        // Display a listing of all the disbursements payees
        const list = SafeJSON.get('creditorList', disbursement);
        if (list === '') {
            return [];
        }
        const creditorList: any[] = Array.from(list.values());
            const sortedList = (creditorList.sort( function(p1, p2) {

            const party1Description = civilCase.getPartyDescriptionByPartyRef(p1.casePartyRef);
            const party2Description = civilCase.getPartyDescriptionByPartyRef(p2.casePartyRef);
            let compare = party1Description.localeCompare(party2Description);

            if (compare !== 0) {
                return compare;
            }
            const p1SeqNum1 = civilCase.getPartyNumberByPartyRef(p1.casePartyRef);
            const p2SeqNum2 = civilCase.getPartyNumberByPartyRef(p2.casePartyRef);
            return p1SeqNum1 - p2SeqNum2;
        })
    );
    return sortedList;
    }
    getDistributionsOnJudgmentMailToName(disbursement: any): string {
        const groupingForIndigentCosts = this.getDistributionIndigentCostsFlag(disbursement);
        if (groupingForIndigentCosts === true) {
            return 'STATE OF NC';
        }
        let mailToName = SafeJSON.getWithDefault('mailToName', disbursement);

        const status = this.getDistributionsOnJudgmentStatus(disbursement);
        if (status === 'MAIL TO OVERRIDDEN') {
            mailToName = 'SEE BOOKKEEPER';
        }
        return mailToName;
    }
    getDistributionsOnJudgmentMailToAddressLine1(disbursement: any): string {
        return SafeJSON.get('mailToAddress.line1', disbursement);
    }
    getDistributionsOnJudgmentMailToAddressLine2(disbursement: any): string {
        return SafeJSON.getWithDefault('mailToAddress.line2', disbursement);
    }
    getDistributionsOnJudgmentMailToAddressLine3(disbursement: any): string {
        const city = SafeJSON.get('mailToAddress.cityName', disbursement);
        const state = SafeJSON.get('mailToAddress.stateAbbreviation.code', disbursement);
        const zipCode = SafeJSON.get('mailToAddress.zipCode', disbursement);
        let zip4 = SafeJSON.get('mailToAddress.zip4', disbursement);
        if (zip4 !== '') {
            zip4 = '-' + zip4;
        }
        if (city === '') {
            return '';
        }
        return city  + ', ' + state + ' ' + zipCode + zip4;
    }
    showDisbursementAddress(disbursement: any): boolean {
        const mailTo = this.getDistributionsOnJudgmentMailToName(disbursement);
        if (mailTo === 'STATE OF NC' || mailTo === 'SEE BOOKKEEPER') {
            return false;
        }
        return true;
    }
    getDistributionIndigentCostsFlag(disbursement: any) {
        return SafeJSON.get('groupingForIndigentCosts', disbursement);
    }
    getDistributionsOnJudgmentPayeeName(civilCase: CivilCase, disbursement: any, creditor: any): string {
        const groupingForIndigentCosts = this.getDistributionIndigentCostsFlag(disbursement);
        if (groupingForIndigentCosts === true) {
            return 'INDIGENT COSTS';
        }
        let partyName = '';
        const abstractPartyAssignmentList: any[] = SafeJSON.get('abstractPartyAssignmentList', creditor);
        if (abstractPartyAssignmentList.length > 0) {
            partyName = SafeJSON.get('assigneeName', abstractPartyAssignmentList[0]);
            // Question to Viparna - keep this part below?  YES
            const assigneeNumber = SafeJSON.get('assignmentNumber', abstractPartyAssignmentList[0]);
            partyName = partyName + ' (ASSIGNEE ' + assigneeNumber + ')';
        } else {
            const partyRef = SafeJSON.getWithDefault('casePartyRef', creditor);
            partyName = civilCase.getPartyNameByPartyRef(partyRef);
            const partyDescription = civilCase.getPartyDescriptionByPartyRef(partyRef);
            const partyNumber = civilCase.getPartyNumberByPartyRef(partyRef);
            if (partyDescription === '-' || partyName === '-' || partyNumber === undefined) {
                return '-';
            }
            partyName = partyName + '(' + partyDescription + ' ' + partyNumber + ')';
        }
        return partyName;
    }
    /*
    FBR405	If an interest amount per day is present for the current period across
            all money details for the judgment, display the total daily interest amount
            accrued per day as
            “Interest accrues at $” + <Daily Interest Amount> + “ per day.”

    FBR450	If a simple interest rate is present for the current period across all
            money details for the judgment, calculate the interest amount per day and display
            the total daily interest amount accrued per day as
            “Interest accrues at $” + <Daily Interest Amount> + “ per day.”

    FBR547  If a combination of simple interest rates and interest amounts per day exist
            for the current period across multiple money details for the judgment,
            calculate the interest amount per day and display the total daily interest amount
            accrued per day as
            “Interest accrues at $” + <Daily Interest Amount> + “ per day.”

    FBR406	If the same compound interest rate is present for the current period across all
            money details for the judgment, display the interest rate as
            “Interest accrues at “ <Interest Rate> + “% compounded daily”.

    FBR407	If multiple compound interest rates exist, or a combination of compound
            interest rate with simple interest rate or an interest amount per day across
            multiple money details for the judgment, display message
            “See clerk for interest calculation.”

    FBR408	If the judgment does not include money awards or an interest rate or a daily
            interest amount is not available for the current period across all money details for
            the judgment, the field will not be displayed.
    >> if dailyInterest is zero, don't show this field
*/
/*  WS build 13.0 has new fields to simplify the UI logic:
    a.	FBR405  moneyIntervalsWithInterestAmountPerDayExists will be true and the rest of the boolean flags will be false
    b.	FBR450  moneyIntervalsWithSimpleInterestRateExists will be true and the rest of the boolean flags will be false
    c.	FBR547  moneyIntervalsWithInterestAmountPerDayExists and
                    moneyIntervalsWithSimpleInterestRateExists will be true and the rest will be false

    d.	FBR406  moneyIntervalsWithSingleCompoundInterestRateExists will be true and
                    the rest will be false. Also dailyCompoundInterestRate will hold the daily Compound Interest rate
    e.	FBR407 moneyIntervalsWithMultipleCompoundInterestRateExists will be true OR
                    a combination of true values for moneyIntervalsWithSingleCompoundInterestRateExists and
                    moneyIntervalsWithInterestAmountPerDayExists / moneyIntervalsWithSimpleInterestRateExists
"abstracts": {
"9102003CVD5398*ABS**CODE*J*NUM*001*T04*2003-12-12 12:39:43.009035": {
    "rowKey": "9102003CVD5398*ABS**CODE*J*NUM*001*T04*2003-12-12 12:39:43.009035",
    "abstractCode": "J",
    "abstractNumber": "1",
    "recordedOnDateTime": "2003-12-12T12:39:43.009035",
    "payoffCalculatedOnDate": "2018-04-05",

    "moneyIntervalsWithInterestAmountPerDayExists": false,
    // will be true if interest amount per day is present on any of the money details on the judgment,
    // for the date when daily interest is calculated

    "moneyIntervalsWithSimpleInterestRateExists": true,
    // will be “true” if a simple interest rate is present across on any of the money details on the judgment,
    // for the date when daily interest is calculated

    "moneyIntervalsWithSingleCompoundInterestRateExists": false,
    // will be “true” If the same compound interest rate is present across the money details on the judgment,
    // for the date when daily interest is calculated

    "moneyIntervalsWithMultipleCompoundInterestRateExists": false,
    // will be “true” If multiple compound interest rates are present on the money details on the judgment,
    // for the date when daily interest is calculated

    “dailyCompoundInterestRate” : 0.5,
    //this will hold the daily Compound interest rate when moneyIntervalsWithSingleCompoundInterestRateExists is true
*/
/*  ###################  NEW REVISION for Rule Implementation (09/26/2018) #####################
 // 09/26/2018   check on the new JSON and do the following revision:
 -----The latest interest rate properties as shown in the case of  ROWAN - 2012CVD3036 (CQ TSD00037717) ---
 moneyIntervalsWithInterestAmountPerDayExists: false
 moneyIntervalsWithInterestAmountPerDayForCurrentPeriodExists: false  (new )
 moneyIntervalsWithSimpleInterestRateExists: true
 moneyIntervalsWithSimpleInterestRateForCurrentPeriodExists: true     (new )
 moneyIntervalsWithSingleCompoundInterestRateExists: true
 moneyIntervalsWithMultipleCompoundInterestRateExists: false
 moneyIntervalsWithCompoundInterestRateForCurrentPeriodExists: true   (new )

 -------- Futher explanation  ------------------------
 "moneyIntervalsWithInterestAmountPerDayExists": false,
 // will be true if interest amount per day is present on any money details on the judgment,

 "moneyIntervalsWithInterestAmountPerDayForCurrentPeriodExist"
 // will be true If an interest amount per day is present for the current period across all money details for the judgment

 "moneyIntervalsWithSimpleInterestRateExists": true,
 // will be “true” if a simple interest rate is present on any of the money details on the judgment,

 "moneyIntervalsWithSimpleInterestRateForCurrentPeriodExists"
 // will be true If a simple interest rate is present for the current period across all money details for the judgment

 "moneyIntervalsWithSingleCompoundInterestRateExists": false,
 // will be “true” If the same compound interest rate is present across the money details on the judgment,

 "moneyIntervalsWithMultipleCompoundInterestRateExists": false,
 // will be “true” If multiple compound interest rates are present on the money details on the judgment,

 "moneyIntervalsWithCompoundInterestRateForCurrentPeriodExists":
 // will be true If compound interest rates exist in any money details

 a.	FBR405  moneyIntervalsWithInterestAmountPerDayForCurrentPeriodExists will be true and the rest of the boolean flags will be false
 b.	FBR450  moneyIntervalsWithSimpleInterestRateForCurrentPeriodExists will be true and the rest of the boolean flags will be false
 c.	FBR547  moneyIntervalsWithInterestAmountPerDayExists
            AND moneyIntervalsWithSimpleInterestRateExists will be true and the rest will be false
 d.	FBR406  moneyIntervalsWithSingleCompoundInterestRateExists will be true and
                    the rest will be false. Also dailyCompoundInterestRate will hold the daily Compound Interest rate
 e.	FBR407  moneyIntervalsWithMultipleCompoundInterestRateExists will be true
            OR a combination of true values for moneyIntervalsWithCompoundInterestRateForCurrentPeriodExists
                    AND (moneyIntervalsWithInterestAmountPerDayExists / moneyIntervalsWithSimpleInterestRateExists)
 //##################################################################################
*/
    // Durham 2004CVD1134 (Simple)  2010CVS4189 (Compound)  2012CVS5018 (Per Day)
    getPayoffCompoundInterestMessage(abstractParty: any): string {
        // Rowan 2017CVS987
        // Nash 1996CVD51008
        // FBR406
       if (this.getMoneyIntervalsWithSingleCompoundInterestRateExists() === true
          && this.getMoneyIntervalsWithCompoundInterestRateForCurrentPeriodExists() === true
          && this.getMoneyIntervalsWithMultipleCompoundInterestRateExists() === false
          && this.getMoneyIntervalsWithInterestAmountPerDayExists() === false
          && this.getMoneyIntervalsWithSimpleInterestRateExists()  === false
          && this.getMoneyIntervalsWithSimpleInterestRateForCurrentPeriodExists() === false
          && this.getMoneyIntervalsWithInterestAmountPerDayForCurrentPeriodExists() === false) {
            // console.log('FBR406');
            let compoundInterestRate =  this.formatInterestRate(this.getDailyCompoundInterestRate());
            return 'Interest accrues at ' + compoundInterestRate  + '% compounded daily.';
        }

        // FBR407
        if (this.getMoneyIntervalsWithMultipleCompoundInterestRateExists() === true
         || (this.getMoneyIntervalsWithCompoundInterestRateForCurrentPeriodExists() === true
            && (this.getMoneyIntervalsWithInterestAmountPerDayExists() === true
              || this.getMoneyIntervalsWithSimpleInterestRateExists() === true ))) {
            // console.log('FBR407');
            return 'See clerk for interest calculation.';
        }

        // else return empty
        return '';
    }
    formatInterestRate(rate: number): Number {
         return Number.parseFloat(rate.toPrecision(6));
    }
    getPayoffCalculatorDailyInterestMessage(abstractParty: any): string {
        const dailyInterestAmount = this.getPayoffDailyInterest(abstractParty);
        const text = this.getPayoffCompoundInterestMessage(abstractParty);
        if (text !== '') {
            return text;
        }

        // FBR 405 FBR450, FBR547
        if ( this.getMoneyIntervalsWithInterestAmountPerDayForCurrentPeriodExists() === true
           || this.getMoneyIntervalsWithSimpleInterestRateForCurrentPeriodExists() === true
           || (this.getMoneyIntervalsWithInterestAmountPerDayExists() === true
             && this.getMoneyIntervalsWithSimpleInterestRateExists()  === true)) {
            return 'Interest accrues at $' +  dailyInterestAmount + ' per day.';
        }
    }
    getMoneyIntervalsWithInterestAmountPerDayExists(): boolean {
        return this.convertToBoolean(SafeJSON.get('moneyIntervalsWithInterestAmountPerDayExists', this.json));
    }
    getMoneyIntervalsWithSimpleInterestRateExists(): boolean {
        return this.convertToBoolean(SafeJSON.get('moneyIntervalsWithSimpleInterestRateExists', this.json));
    }
    getMoneyIntervalsWithMultipleCompoundInterestRateExists(): boolean {
        return this.convertToBoolean(SafeJSON.get('moneyIntervalsWithMultipleCompoundInterestRateExists', this.json));
    }
    getMoneyIntervalsWithSingleCompoundInterestRateExists(): boolean {
        return this.convertToBoolean(SafeJSON.get('moneyIntervalsWithSingleCompoundInterestRateExists', this.json));
    }
    getMoneyIntervalsWithCompoundInterestRateForCurrentPeriodExists(): boolean {
        return this.convertToBoolean(SafeJSON.get('moneyIntervalsWithCompoundInterestRateForCurrentPeriodExists', this.json));
    }
    getMoneyIntervalsWithInterestAmountPerDayForCurrentPeriodExists(): boolean {
        return this.convertToBoolean(SafeJSON.get('moneyIntervalsWithInterestAmountPerDayForCurrentPeriodExists', this.json));
    }
    getMoneyIntervalsWithSimpleInterestRateForCurrentPeriodExists(): boolean {
        return this.convertToBoolean(SafeJSON.get('moneyIntervalsWithSimpleInterestRateForCurrentPeriodExists', this.json));
    }
    getDailyCompoundInterestRate(): number {
        return SafeJSON.getNumber('dailyCompoundInterestRate', this.json) * 100;
    }
    // we may not need this method
    getShowPayoffInterestMessage(abstractParty: any): boolean {
        const payoffDailyInterest = this.getPayoffDailyInterest(abstractParty);
        if (payoffDailyInterest === null || payoffDailyInterest === 0) {
            // return false;
        }
        return true;
    }
    getPayoffDailyInterest(abstractParty: any): number {
        return SafeJSON.getNumber('abstractPayoff.dailyInterest', abstractParty.json);
    }
    // Ordered
    getPayoffCalculatorOrderedMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalPrincipal', abstractParty.json);
    }
    getPayoffCalculatorOrderedInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalInterest', abstractParty.json);
    }
    getPayoffCalculatorOrderedCostsAndFees(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalCost', abstractParty.json);
    }
    getPayoffCalculatorOrderedTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalAmount', abstractParty.json);
    }
    // Paid
    getPayoffCalculatorPaidMoneyAward(abstractParty: any): number {
        let num: number = SafeJSON.getNumber('abstractPayoff.totalPrincipalPaid', abstractParty.json);
        return Abstract.convertToNegativeNumber(num);
    }
    getPayoffCalculatorPaidInterest(abstractParty: any): Number {
        return Abstract.convertToNegativeNumber(SafeJSON.getNumber('abstractPayoff.totalInterestPaid', abstractParty.json));
    }
    getPayoffCalculatorPaidCostsAndFees(abstractParty: any): Number {
        return Abstract.convertToNegativeNumber(SafeJSON.getNumber('abstractPayoff.totalCostPaid', abstractParty.json));
    }
    getPayoffCalculatorPaidTotal(abstractParty: any): Number {
        return Abstract.convertToNegativeNumber(SafeJSON.getNumber('abstractPayoff.totalPaid', abstractParty.json));
    }
    // Balance
    getPayoffCalculatorBalanceMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.principalBalance', abstractParty.json);
    }
    getPayoffCalculatorBalanceInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.interestBalance', abstractParty.json);
    }
    getPayoffCalculatorBalanceCostsAndFees(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.costBalance', abstractParty.json);
    }
    getPayoffCalculatorBalanceTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalBalance', abstractParty.json);
    }
    getPayoffCalculatorCreditorUnpaidDeferredCosts(abstractParty: any): Number {
        return SafeJSON.getNumber('unPaidIndigentCosts', abstractParty.json);
    }
    getPayoffCalculatedDate(): string {
        return SafeJSON.get('payoffCalculatedOnDate', this.json);
    }
    getAttorneyFeeTypeTBDExists(abstractParty: any): boolean {
        return SafeJSON.get('abstractPayoff.attorneyFeeTypeTBDExists', abstractParty.json);
    }
    getPayoffCalculatorMaxLiabiltyMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalPrincipal', abstractParty.json);
    }
    getPayoffCalculatorMaxLiabiltyCostsAndFees(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalPrincipal', abstractParty.json);
    }
    getPayoffCalculatorMaxLiabiltyInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalPrincipal', abstractParty.json);
    }
    getPayoffCalculatorMaxLiabiltyTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('abstractPayoff.totalPrincipal', abstractParty.json);
    }
    getShowCalculatedPayoffAmount(abstractParty: any): boolean {
        if (this.getAttorneyFeeTypeTBDExists(abstractParty) === true) {
            return false;
        }
        const specialList: any[] = SafeJSON.get('abstractSpecialDetailsList', this.json);
        if (specialList.length !== 0) {
            return false;
        }
        if (this.isPropertyAwardDetailOnlyAwardDetail() === true) {
            return false;
        }
        return true;
    }
    getIssueClockedInDate(civilCase: CivilCase, pleadingKey: string): string {
        const pleading: Pleading = civilCase.getPleadingByKey(pleadingKey);
        if (pleading) {
            return pleading.getClockDate();
        }
        return '';
    }
    getPleadingTypeDescription(civilCase: CivilCase, pleadingKey: string): string {
        const pleading: Pleading = civilCase.getPleadingByKey(pleadingKey);
        if (pleading) {
          return pleading.getPleadingTypeDescription();
        }
        return '-';
    }
    getIssueType(civilCase: CivilCase, issue: Issue): string {
        const issueType = issue.getTypeReplaceOther();
        return issueType;
    }
    returnIfNotEmpty(source: string, displayString: string): string {
        if (source === '' || source === '-') {
            return '';
        }
        return displayString;
    }
    showPayoffCalculation(i: number) {
        this.payoffCalculationsShowFlag[i] = true;
    }
    hidePayoffCalculation(i: number) {
        this.payoffCalculationsShowFlag[i] = false;
    }
    getPayoffCalculationsShowFlag(i: number): boolean {
        return this.payoffCalculationsShowFlag[i];
    }
    logToConsoleAndServer(text: string) {
        JL().error(text);
        console.log(text);
    }
    convertToBoolean(value: boolean): boolean {
        if (value === true) {
            return true;
        }
        return false;
    }
}





// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/abstract.ts